// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SpacePanel__container-e91a5a {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  position: relative;
  height: 100%;
}

.SpacePanel__divider-a9fb86 {
  background-color: var(--base-20);
  margin: 8px 0;
  height: 1px;
}

.SpacePanel__groups-e1454f {
  flex-grow: 1;
}`, "",{"version":3,"sources":["webpack://./src/main/SidebarPanel/SpacePanel/SpacePanel.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;AACF;;AAEA;EACE,gCAAA;EACA,aAAA;EACA,WAAA;AACF;;AAEA;EACE,YAAA;AACF","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n  position: relative;\n  height: 100%;\n}\n\n.divider {\n  background-color: var(--base-20);\n  margin: 8px 0;\n  height: 1px;\n}\n\n.groups {\n  flex-grow: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `SpacePanel__container-e91a5a`,
	"divider": `SpacePanel__divider-a9fb86`,
	"groups": `SpacePanel__groups-e1454f`
};
module.exports = ___CSS_LOADER_EXPORT___;
